import produce from "immer";

import { Maybe, Resource, Tag } from "@examspark/types";

import GraphQLAPI from "..";

import { updateResource } from "./resource";

export const addTags = async (resource: Resource, tagsToAdd: Tag[]) => {
  const result = await GraphQLAPI.client.query<{ getResource: Resource }>({
    query: /* GraphQL */ `
      query GetTags($id: ID!, $sk: String!) {
        getResource(id: $id, sk: $sk) {
          tags {
            key
            type
            value
          }
        }
      }
    `,
    variables: {
      id: resource.id,
      sk: resource.sk,
    },
  });

  const tags: Maybe<Maybe<Tag>[]> = result.data?.getResource.tags || [];

  for (const tag of tagsToAdd) {
    if (!tag) continue;
    if (
      tags.find((_tag) => _tag?.key === tag.key && _tag?.value === tag.value)
    ) {
      continue;
    }
    tags.push(tag);
  }

  console.log("tags", tags);

  const updateResult = await updateResource({
    id: resource.id,
    sk: resource.sk,
    tags: tags,
  });

  return updateResult.data?.updateResource;
};

export const removeTags = async (resource: Resource, tagsToRemove: Tag[]) => {
  const result = await GraphQLAPI.client.query<{ getResource: Resource }>({
    query: /* GraphQL */ `
      query GetTags($id: ID!, $sk: String!) {
        getResource(id: $id, sk: $sk) {
          tags {
            key
            type
            value
          }
        }
      }
    `,
    variables: {
      id: resource.id,
      sk: resource.sk,
    },
  });

  if (!result.data?.getResource.tags) return;

  const tags: Maybe<Tag>[] = produce(
    result.data?.getResource.tags || [],
    (draft) => {
      for (const tag of tagsToRemove) {
        if (!tag) continue;
        const findIndex = draft?.findIndex(
          (_tag) => _tag?.key === tag.key && _tag?.value === tag.value,
        );

        if (findIndex !== -1) {
          draft.splice(findIndex, 1);
        }
      }
    },
  );

  console.log("new tags", tags);

  const updateResult = await updateResource({
    id: resource.id,
    sk: resource.sk,
    tags: tags,
  });

  return updateResult.data?.updateResource;
};
